<template>
  <div class="wrap-device-list">
    <div class="response_table">
      <table>
        <thead
            ref="tableHead"
            class="table-device-list_bg"
            :class="(filters_state)? 'device-list_fiters_is--show' : 'device-list_fiters_is--hidden'"
        >
        <tr>
          <th
              scope="col"
              class="status table-device-list_mob-filters"
          >
            <toggle-switch-device-status
                v-model="filter.status"
                :disabled="false"
                :name="name"
                @toggle="change_status"
            />
          </th>
          <th
              scope="col"
              class="table-device-list_mob-filters"
          >
            <tag-list-popup
                v-model="filter.name"
                :label="'ID / ' + translate('device.name')"
                @input="change_input"
            />
          </th>

          <th scope="col" class="custom_tag sim_status">
            Simcard Status
          </th>

          <th
              scope="col"
              class="table-device-list_mob-filters"
          >
            <tag-list-popup
                v-model="filter.place"
                :label="translate('device.place')"
                @input="change_input"
            />
          </th>
          <th
              scope="col"
              class="table-device-list_mob-filters"
          >
            <tag-list-popup
                v-model="filter.desc"
                :label="translate('device.desc')"
                @input="change_input"
            />
          </th>
          <th
              scope="col"
              class="table-device-list_mob-filters"
          >
            <tag-list-popup
                v-model="filter.ip"
                :label="translate('IP')"
                @input="change_input"
            />
          </th>
          <th scope="col" class="uptime">
            Uptime
          </th>
          <th style="width: 15px" />
        </tr>
        </thead>
        <tbody
            ref="tableDevice"
            style="position: relative"
            @scroll.passive="paint_chart($event)"
        >
        <tr
            v-if="load"
            style="border:none; background-color:  transparent;"
        >
          <td> <scale-loader /> </td>
        </tr>
        <device-item
            v-for="(item,index) in trs"
            ref="myDevice"
            class="device_item"
            :key="index"
            :index="index"
            :item="item"
            :checkbox="item.checkbox"
        />
        <tr
            v-if="afterload"
            style="border:none; background-color:  transparent;"
        >
          <td> <scale-loader /> </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import DeviceItem from './DeviceItem.vue'
import ToggleSwitchDeviceStatus from "components/UIComponents/ToggleSwitch/ToggleSwitchDeviceStatus";
import TagListPopup from "components/UIComponents/Tags/TagListPopup";

export default {
  name: 'DeviceGroupList',
  components: {
    DeviceItem,
    ToggleSwitchDeviceStatus,
    TagListPopup
  },
  data () {
    return {
      range: false,
      cur_item: {},
      load: true,
      top: 0,
      ids: [],
      interval_update: null,
      afterload: false,
      group_cnt: {},
      tableData: {},
      trs: [],
      timer: null,
      timer_res: null,
      name: '',
      cur_page: 1,
      next_page: 1,
      pages: 0,
      timer_chart: null,
      menuData: {},
      rendList: [],
      resizeList: [],
      filter: {},
      head_tr: '',
      group_head: [],
      group: [],
      status_option: [],
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true
    }
  },
  computed: {
    group_id () {
      if ( this.$route.name === 'device_list_group' ) {
        this.$store.commit('updateOtherTitle', this.$store.getters.getDeviceGroupById(this.$route.params.device_group_id).name)
        return this.$route.params.device_group_id
      } else {
        return -1
      }
    },
    proveCopy () {
      return (navigator.clipboard !== undefined)
    }
  },

  watch: {
   group_id () {
     if (this.group_id !== -1) {
       this.filter.group = [+this.group_id]
       this.tableData = []
       this.load = true
       this.get_device()
     }

   },
   tableData () {
      var trs = [] // 0 - название группы, 1 - элемент
      this.group_head = []

      for (let i in this.tableData) {
        for (let j in this.tableData[i]) {
          if ((this.online && this.tableData[i][j].status) || !this.online) {
            this.tableData[i][j].type = 1
            this.tableData[i][j].checkbox = false
            trs.push(this.tableData[i][j])
          }
        }
      }

      if (trs.length === 0) {
        this.head_tr = 'No result'
        this.trs = []
      } else {
        this.$set(this, 'trs', trs)
      }
      this.load = false
      this.afterload = false
      this.$nextTick(this.mountItem)
      return true
    }
  },
  created () {
    this.init()
    window.addEventListener('resize', this.handleResize)
  },

  activated () {
    this.$refs.tableDevice.scrollTop = this.top
    if (this.$store.getters.getDeviceListChange) {
      this.init()
      this.$store.commit('setDeviceListChange', false)
    } else {
      clearInterval(this.interval_update)
      this.interval_update = setInterval(this.update_status, this.$store.getters.getDeviceGroupListUpdate)
    }

    window.addEventListener('resize', this.handleResize)
  },

  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },

  deactivated () {
    this.$store.commit('updateOtherTitle', '')
    this.top = this.$refs.tableDevice.scrollTop
    clearInterval(this.interval_update)
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    update_status () {
      this.date = new Date()
      for (let i = 1; i <= this.cur_page; i++) {
        this.$http.v1.getDevices(i, this.filter, (response) => {
          this.pages = response.data.pages
          this.group_cnt = Object.assign(this.group_cnt, {...response.data.groups})
          this.filter_result = {devices: response.data.count, pages: response.data.pages}
          for (let i in response.data.devices) {
            if (this.tableData[i] === undefined) {
              this.tableData[i] = {}
            }
            for (let j in response.data.devices[i]) {
              if (this.tableData[i][j] === undefined) {
                this.tableData[i][j] = {}
              }
              for (let k in response.data.devices[i][j]) {
                this.tableData[i][j][k] = response.data.devices[i][j][k]
              }
              this.tableData[i][j].offline = response.data.devices[i][j].offline
            }
          }

        })
      }
    },
    change_status (name, value) {
      this.filter.status[name] = value
      this.change_input()
    },

    handleResize () {
      if (this.timer_res !== null) {
        clearTimeout(this.timer_res)
      }
      this.timer_res = setTimeout(() => { this.resizeList = [...this.$refs.myDevice]; this.paint_chart() }, 300)
    },

    init () {
      this.$store.dispatch('add_link_group_device', this.group_id)
      this.filter = {server: [], group: [+this.group_id], desc: [], place: [], name: [], ip: [], status: { online: false, backup: false, error: false }}
      this.date = new Date()
    },

    paint_chart () {
      let tmpRend = []
      let table = this.$refs.tableDevice
      for (let i in this.resizeList) {
        if ((this.resizeList[i].$el.offsetTop > (table.scrollTop - 40)) && this.resizeList[i].$el.offsetTop < (table.scrollTop + table.clientHeight + 40)) {
          if (this.resizeList[i].chartStatus === true) {
            this.resizeList[i].resize = !this.resizeList[i].resize
          }
        } else {
          tmpRend.push(this.resizeList[i])
        }
      }

      if (tmpRend.length > 0) {
        this.resizeList = [...tmpRend]
      }

      tmpRend = []
      for (let i in this.rendList) {
        if ((this.rendList[i].$el.offsetTop > (table.scrollTop - 40)) && this.rendList[i].$el.offsetTop < (table.scrollTop + table.clientHeight + 40)) {
          this.rendList[i].chartStatus = true
        } else {
          tmpRend.push(this.rendList[i])
        }
      }
      this.rendList = tmpRend
      if ((table.scrollTop >= table.scrollHeight - (table.clientHeight * 3)) && !this.afterload) {
        if (this.cur_page < this.pages) {
          this.add_device_in_list()
        }
      }
    },

    mountItem () {
      if (this.trs.length === 0) {
        return false
      }
      let length = (this.$refs.myDevice.length < 25) ? this.$refs.myDevice.length : 25

      for (let i = 0; i < length; i++) {
        this.$refs.myDevice[i].chartStatus = true
      }
      if (length < this.$refs.myDevice.length) {
        for (let i = 25; i < this.$refs.myDevice.length; i++) {
          this.rendList.push(this.$refs.myDevice[i])
        }
      }
    },
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.get_device, 1000)
    },

    get_device () {
      this.load = true
      this.group_head = []

      clearInterval(this.interval_update)
      this.interval_update = setInterval(this.update_status, this.$store.getters.getDeviceListUpdate)
      this.rendList = []

      let filter = this.filter
      this.$store.dispatch('setDeviceFilter', filter)
      this.localStorage.setItem('filter_devices', JSON.stringify(filter))

      this.$http.v1.getDevices(1, filter, (response) => {
        this.pages = response.data.pages
        this.next_page = response.data.next_page
        this.cur_page = response.data.current_page
        this.group_cnt = {...response.data.groups}
        this.hash = response.data.hash
        this.filter_result = {devices: response.data.count, pages: response.data.pages}
        this.tableData = {...response.data.devices}

        for (let i in this.tableData) {
          for (let j in this.tableData[i]) {
            this.$set(this.tableData[i][j], 'checked', false)
          }
        }
      })
    },

    add_device_in_list () {
      this.afterload = true
      this.$http.v1.getDevices(this.next_page, {...this.filter}, (response) => {
        let tmp = {...this.tableData}
        for (let i in response.data.devices) {
          if (tmp[i] === undefined) {
            tmp[i] = {}
          }
          for (let j in response.data.devices[i]) {
            tmp[i][j] = response.data.devices[i][j]
          }
        }
        this.tableData = {...tmp}

        this.cur_page = response.data.current_page
        this.next_page = response.data.next_page
        this.group_cnt = Object.assign(this.group_cnt, {...response.data.groups})
      })
    },
  }
}
</script>
